import React from "react";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import f_logo from "../../images/icar.png";
import s_logo from "../../images/nihep.png";
import t_logo from "../../images/iasri.png";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "0",
    display: "inline-flex",
    width: "auto",
  },
  resplogo: {
    width: "100%",
    height: "auto",
    maxWidth: "100%",
    padding: "0 5px",
  },
}));

const messages = {};
export default function Logocomp(props) {
  const { logoHeight } = props;
  const classes = useStyles();

  return (
    <React.Fragment>
      <Grid container spacing={2} className={classes.root}>
        <Grid item xs={12}>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            style={{ padding: "0 10px" }}
          >
            <Box>
              <img
                src={f_logo}
                className={classes.resplogo}
                style={{ height: logoHeight ? logoHeight : "108px", width : "auto" }}
              />
            </Box>
            <Box>
              <img
                src={s_logo}
                className={classes.resplogo}
                style={{ height: logoHeight ? logoHeight : "60px" , width : "auto" }}
              />
            </Box>
            <Box>
              <img
                src={t_logo}
                className={classes.resplogo}
                style={{ height: logoHeight ? logoHeight : "", width : "auto"  }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
